import CreateCreativeIcon from '@/components/Icons/CreateCreativeIcon';
import CloseButton from '@/components/Modal/common/CloseButton';

interface ICreativesModalHeaderProps {
  handleClose: () => void;
}

const CreativesModalHeader = ({ handleClose }: ICreativesModalHeaderProps) => (
  <div className='bg-[#1b433224] relative h-[120px] w-full rounded-xl'>
    <div className='flex h-full justify-left items-center'>
      <div className='flex justify-center items-center ml-6'>
        <CreateCreativeIcon width={104} height={106} />
      </div>
      <div className='flex ml-6 h-full justify-center items-center'>
        <span className='#1E1E1E text-2xl font-semibold'>{'Add Creative Association'}</span>
      </div>
      <div className='absolute right-[16px] top-[16px]'>
        <CloseButton onClick={handleClose} />
      </div>
    </div>
  </div>
);

export default CreativesModalHeader;
